import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import MedicalServicesRoundedIcon from '@mui/icons-material/MedicalServicesRounded';
import PriceCheckRoundedIcon from '@mui/icons-material/PriceCheckRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';

const BENEFITS = [
  {
    icon: <MedicalServicesRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Especialização',
    description: 'Atendimento voltado para profissionais da saúde.',
  },
  {
    icon: <PriceCheckRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Custo-benefício',
    description: 'Análise de alternativas adequadas ao seu perfil.',
  },
  {
    icon: <TuneRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Opções para sua realidade',
    description: 'Soluções considerando empresa, família e necessidades.',
  },
  {
    icon: <HandshakeRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Atendimento humano',
    description: 'Acompanhamento especializado durante todo o processo.',
  },
  {
    icon: <BoltRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Processo simples',
    description: 'Menos burocracia para entender suas possibilidades.',
  },
  {
    icon: <VerifiedUserRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Segurança e confiança',
    description: 'Tratamento responsável das informações fornecidas.',
  },
];

const BeneficiosSection: React.FC = () => {
  return (
    <Box
      id="beneficios"
      component="section"
      sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.default', scrollMarginTop: { xs: 88, md: 100 } }}
    >
      <Container maxWidth="lg">
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 7 }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '0.8rem',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'secondary.dark',
              mb: 1.5,
            }}
          >
            Benefícios
          </Typography>
          <Typography variant="h2" sx={{ fontSize: { xs: '1.75rem', md: '2.25rem' } }}>
            Por que escolher a MedPrime Benefícios?
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {BENEFITS.map((item, index) => (
            <Grid item key={item.title} xs={12} sm={6} md={4}>
              <Card
                component={motion.div}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.06 }}
                variant="outlined"
                sx={{ height: '100%', border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}
              >
                <CardContent sx={{ p: 3.5 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: '12px',
                      bgcolor: 'rgba(14, 75, 79, 0.08)',
                      color: 'primary.main',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2.5,
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography sx={{ fontWeight: 700, fontSize: '1.05rem', mb: 1 }}>
                    {item.title}
                  </Typography>
                  <Typography sx={{ fontSize: '0.9rem', color: 'text.secondary', lineHeight: 1.6 }}>
                    {item.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default BeneficiosSection;
